import React from 'react'
import styles from '../Proj1Folder/Proj1.module.css'
import elite1 from '../../Images/elite1.jpeg'
import elite2 from '../../Images/elite2.jpeg'
import elite3 from '../../Images/elite3.jpeg'
import elite4 from '../../Images/elite4.jpeg'
import elite5 from '../../Images/elite5.jpeg'
import elite6 from '../../Images/elite6.jpeg'
import elite7 from '../../Images/elite7.jpeg'
import elite8 from '../../Images/elite8.jpeg'
import elite9 from '../../Images/elite9.jpeg'
import elite10 from '../../Images/elite10.jpeg'
import elite11 from '../../Images/elite11.jpeg'






export default function Elite() {
  return (

    <>
        <div className="container my-5 py-5 ">
          <div className="row  align-items-center">
            <div className="col-md-6">
            <h3 className={`${styles.color} my-3`}> Rabie al – takyeef factory , 6th of October city ​</h3>
                <p> Project description: : admin and production hall     </p>
                <p>Type of contract: design and supervision  </p>
                <p> Area:  8000 m2 </p>
                <p>Type of works : architectural , civil and electromechanical design </p>
            </div>
            <div className="col-md-6">
                <img src={elite1} alt="achegy" className='img-fluid'/>
            </div>   

          </div>
       <div className="row my-5">
          <div className="col-md-4 my-1 text-center">
               <img src={elite2} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-4 my-1 text-center">
               <img src={elite3} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-4 my-1 text-center">
               <img src={elite4} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                        <div className="col-md-4 my-1 text-center">
               <img src={elite5} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>            <div className="col-md-4 my-1 text-center">
               <img src={elite6} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>            <div className="col-md-4 my-1 text-center">
               <img src={elite8} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>            <div className="col-md-4 my-1 text-center">
               <img src={elite9} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>            <div className="col-md-4 my-1 text-center">
               <img src={elite10} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>            <div className="col-md-4 my-1 text-center">
               <img src={elite11} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>            <div className="col-md-4 my-1 text-center">
               <img src={elite7} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>           
       
          </div>
        </div>

    </>
  )
}
